import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface SetShowWelcomeScreenParams {
  showWelcomeScreen: boolean;
}

export class SetShowWelcomeScreenRequest extends Request<SetShowWelcomeScreenParams, IResult> {
  constructor(params: SetShowWelcomeScreenParams) {
    super('setShowWelcomeScreen', params);
  }
}
